import React from 'react';
import { useTranslations } from 'next-intl';
import Image from "next/legacy/image";

const WrappingDonationBanner: React.FC = () => {
  const t = useTranslations();

  return (
    <div className="relative w-full overflow-hidden rounded-xl">
      {/* Background pattern */}
      <div className="absolute inset-0 bg-[#FF8A3D]">
        <div className="absolute inset-0 bg-[url(/svgs/ramadan-bg.svg)] bg-cover" />
      </div>

      {/* Content */}
      <div className="relative px-4 py-6 text-white">
        <div className="flex items-center justify-between">
          <div className="">
            <div className="flex items-center gap-2">

              <div className="max-h-[50px] max-w-[50px] scale-90  md:hidden">
                <Image
                  src="/imgs/dabdoob-unpacking-gift.webp"
                  alt="dabdoob-unpacking-gift"
                  width={50}
                  height={50}
                />
              </div>
              <h2 className="text-lg md:text-xl font-bold mb-2 ">
                {t('SKIP THE WRAP SHARE THE LOVE')}
              </h2>
            </div>
            <p className="text-sm">
              {t('By opting out of gift wrapping help us to redirect a fixed amount to support refugee children in need')}
            </p>
          </div>
          <div className="max-h-[119px] max-w-[119px] scale-90 mx-8 hidden md:block">
            <Image
              src="/imgs/dabdoob-unpacking-gift.webp"
              alt="dabdoob-unpacking-gift"
              width={119}
              height={119}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WrappingDonationBanner; 